import pathfinder from '@fiverr-private/pathfinder';
import PATHFINDER from '../../../../shared/constants/pathfinder';
import { translate } from '../../../../shared/utils';
import { PATHS } from '../../constants';

export const getStaticPagePath = ({ categoryId, id, nestedSubCategoryId, filterId }, source, locale) => {

    if (!(categoryId && id && filterId)) {
        return PATHS.ROOT;
    }

    if (isNaN(parseInt(categoryId, 10)) || isNaN(parseInt(id, 10)) || (nestedSubCategoryId && (parseInt(nestedSubCategoryId, 10)))) {
        return PATHS.ROOT;
    }

    const categorySlug = translate(`categories.category_${categoryId}.cached_slug`, locale);
    const subCategorySlug = translate(`sub_categories.sub_category_${id}.cached_slug`, locale);

    let params = {
        category_id: categorySlug,
        id: subCategorySlug,
        filters_uid: filterId
    };
    const options = { query: { source } };

    if (nestedSubCategoryId) {
        const nestedSubCategorySlug = translate(`sub_categories.sub_category_${id}.nested_sub_cat_${nestedSubCategoryId}.cached_slug`, locale);

        params = {
            ...params,
            nested_sub_category_id: nestedSubCategorySlug
        };

        return pathfinder(PATHFINDER.NESTED_SUB_CATEGORY_STATIC_PAGE, params, options);
    }

    return pathfinder(PATHFINDER.SUB_CATEGORY_STATIC_PAGE, params, options);
};
